import { createContext } from 'react';

const MercadoPagoInstanceContext = createContext();

export default MercadoPagoInstanceContext;
